'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';
import * as pixel from '../lib/fpixel';

const FacebookPixel = () => {
  const pathname = usePathname();
  const firstPath = useRef(true);

  // The first page view is sent by the inline script itself, right after init: next/script's
  // onLoad never fires for an inline script, so waiting on it sent no page view at all and the
  // site relied on Tag Manager for every one (ME-4822). This covers in-site navigations.
  useEffect(() => {
    if (firstPath.current) {
      firstPath.current = false;
      return;
    }
    if (typeof window.fbq === 'function') pixel.pageview();
  }, [pathname]);

  return (
    <div>
      <Script
        id="fb-pixel"
        strategy="afterInteractive"
        data-pixel-id={pixel.FB_PIXEL_ID}
      >{`const PIXEL_ID = document.currentScript.getAttribute("data-pixel-id");

function initializeFacebookPixel(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
}

initializeFacebookPixel(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js",
);

// Meta's automatic events (button clicks, page metadata) are noise we do not choose (ME-4822).
window.fbq("set", "autoConfig", false, PIXEL_ID);
window.fbq("init", PIXEL_ID);
window.fbq("track", "PageView");`}</Script>
    </div>
  );
};

export default FacebookPixel;
